/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Activity_Panel_PreviousInputs */



/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Chat_Activity_Panel_PreviousInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_activity_panel_previous = /** @type {((inputs?: Chat_Activity_Panel_PreviousInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Activity_Panel_PreviousInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Vorige")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Précédent")
	return /** @type {LocalizedString} */ ("Previous")
});